export {FullyQualifiedBanner} from './FullyQualifiedBanner';
